const middleware = {}

middleware['account'] = require('../middleware/account.js')
middleware['account'] = middleware['account'].default || middleware['account']

middleware['admin'] = require('../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['amounts'] = require('../middleware/amounts.js')
middleware['amounts'] = middleware['amounts'].default || middleware['amounts']

middleware['blog/articles'] = require('../middleware/blog/articles.js')
middleware['blog/articles'] = middleware['blog/articles'].default || middleware['blog/articles']

middleware['blog/related-product'] = require('../middleware/blog/related-product.js')
middleware['blog/related-product'] = middleware['blog/related-product'].default || middleware['blog/related-product']

middleware['breadcrumbs'] = require('../middleware/breadcrumbs.js')
middleware['breadcrumbs'] = middleware['breadcrumbs'].default || middleware['breadcrumbs']

middleware['data-for-nav'] = require('../middleware/data-for-nav.js')
middleware['data-for-nav'] = middleware['data-for-nav'].default || middleware['data-for-nav']

middleware['feefo'] = require('../middleware/feefo.js')
middleware['feefo'] = middleware['feefo'].default || middleware['feefo']

middleware['jumbotron'] = require('../middleware/jumbotron.js')
middleware['jumbotron'] = middleware['jumbotron'].default || middleware['jumbotron']

middleware['media/guide'] = require('../middleware/media/guide.js')
middleware['media/guide'] = middleware['media/guide'].default || middleware['media/guide']

middleware['media/guides'] = require('../middleware/media/guides.js')
middleware['media/guides'] = middleware['media/guides'].default || middleware['media/guides']

middleware['media/videos'] = require('../middleware/media/videos.js')
middleware['media/videos'] = middleware['media/videos'].default || middleware['media/videos']

middleware['meta-tags'] = require('../middleware/meta-tags.js')
middleware['meta-tags'] = middleware['meta-tags'].default || middleware['meta-tags']

middleware['orders/home-insurance'] = require('../middleware/orders/home-insurance.js')
middleware['orders/home-insurance'] = middleware['orders/home-insurance'].default || middleware['orders/home-insurance']

middleware['orders/life-insurance-application'] = require('../middleware/orders/life-insurance-application.js')
middleware['orders/life-insurance-application'] = middleware['orders/life-insurance-application'].default || middleware['orders/life-insurance-application']

middleware['pages/about/index'] = require('../middleware/pages/about/index.js')
middleware['pages/about/index'] = middleware['pages/about/index'].default || middleware['pages/about/index']

middleware['pages/about/team'] = require('../middleware/pages/about/team.js')
middleware['pages/about/team'] = middleware['pages/about/team'].default || middleware['pages/about/team']

middleware['pages/accredited-by-cru'] = require('../middleware/pages/accredited-by-cru.js')
middleware['pages/accredited-by-cru'] = middleware['pages/accredited-by-cru'].default || middleware['pages/accredited-by-cru']

middleware['pages/awards'] = require('../middleware/pages/awards.js')
middleware['pages/awards'] = middleware['pages/awards'].default || middleware['pages/awards']

middleware['pages/car-home-insurance-under-maintenance'] = require('../middleware/pages/car-home-insurance-under-maintenance.js')
middleware['pages/car-home-insurance-under-maintenance'] = middleware['pages/car-home-insurance-under-maintenance'].default || middleware['pages/car-home-insurance-under-maintenance']

middleware['pages/car-insurance/thank-you'] = require('../middleware/pages/car-insurance/thank-you.js')
middleware['pages/car-insurance/thank-you'] = middleware['pages/car-insurance/thank-you'].default || middleware['pages/car-insurance/thank-you']

middleware['pages/careers'] = require('../middleware/pages/careers.js')
middleware['pages/careers'] = middleware['pages/careers'].default || middleware['pages/careers']

middleware['pages/commission-summary'] = require('../middleware/pages/commission-summary.js')
middleware['pages/commission-summary'] = middleware['pages/commission-summary'].default || middleware['pages/commission-summary']

middleware['pages/competitions'] = require('../middleware/pages/competitions.js')
middleware['pages/competitions'] = middleware['pages/competitions'].default || middleware['pages/competitions']

middleware['pages/csr'] = require('../middleware/pages/csr.js')
middleware['pages/csr'] = middleware['pages/csr'].default || middleware['pages/csr']

middleware['pages/customer-satisfaction/broadband'] = require('../middleware/pages/customer-satisfaction/broadband.js')
middleware['pages/customer-satisfaction/broadband'] = middleware['pages/customer-satisfaction/broadband'].default || middleware['pages/customer-satisfaction/broadband']

middleware['pages/energy/index'] = require('../middleware/pages/energy/index.js')
middleware['pages/energy/index'] = middleware['pages/energy/index'].default || middleware['pages/energy/index']

middleware['pages/guaranteed-irish'] = require('../middleware/pages/guaranteed-irish.js')
middleware['pages/guaranteed-irish'] = middleware['pages/guaranteed-irish'].default || middleware['pages/guaranteed-irish']

middleware['pages/health-insurance/thank-you'] = require('../middleware/pages/health-insurance/thank-you.js')
middleware['pages/health-insurance/thank-you'] = middleware['pages/health-insurance/thank-you'].default || middleware['pages/health-insurance/thank-you']

middleware['pages/help'] = require('../middleware/pages/help.js')
middleware['pages/help'] = middleware['pages/help'].default || middleware['pages/help']

middleware['pages/home-insurance/thank-you'] = require('../middleware/pages/home-insurance/thank-you.js')
middleware['pages/home-insurance/thank-you'] = middleware['pages/home-insurance/thank-you'].default || middleware['pages/home-insurance/thank-you']

middleware['pages/homepage'] = require('../middleware/pages/homepage.js')
middleware['pages/homepage'] = middleware['pages/homepage'].default || middleware['pages/homepage']

middleware['pages/life-insurance/thank-you'] = require('../middleware/pages/life-insurance/thank-you.js')
middleware['pages/life-insurance/thank-you'] = middleware['pages/life-insurance/thank-you'].default || middleware['pages/life-insurance/thank-you']

middleware['pages/market-analysis'] = require('../middleware/pages/market-analysis.js')
middleware['pages/market-analysis'] = middleware['pages/market-analysis'].default || middleware['pages/market-analysis']

middleware['pages/media/ads'] = require('../middleware/pages/media/ads.js')
middleware['pages/media/ads'] = middleware['pages/media/ads'].default || middleware['pages/media/ads']

middleware['pages/media/article'] = require('../middleware/pages/media/article.js')
middleware['pages/media/article'] = middleware['pages/media/article'].default || middleware['pages/media/article']

middleware['pages/media/authors'] = require('../middleware/pages/media/authors.js')
middleware['pages/media/authors'] = middleware['pages/media/authors'].default || middleware['pages/media/authors']

middleware['pages/media/blog'] = require('../middleware/pages/media/blog.js')
middleware['pages/media/blog'] = middleware['pages/media/blog'].default || middleware['pages/media/blog']

middleware['pages/media/guide'] = require('../middleware/pages/media/guide.js')
middleware['pages/media/guide'] = middleware['pages/media/guide'].default || middleware['pages/media/guide']

middleware['pages/media/guides'] = require('../middleware/pages/media/guides.js')
middleware['pages/media/guides'] = middleware['pages/media/guides'].default || middleware['pages/media/guides']

middleware['pages/media/in-the-media'] = require('../middleware/pages/media/in-the-media.js')
middleware['pages/media/in-the-media'] = middleware['pages/media/in-the-media'].default || middleware['pages/media/in-the-media']

middleware['pages/media/newsroom'] = require('../middleware/pages/media/newsroom.js')
middleware['pages/media/newsroom'] = middleware['pages/media/newsroom'].default || middleware['pages/media/newsroom']

middleware['pages/media/podcast'] = require('../middleware/pages/media/podcast.js')
middleware['pages/media/podcast'] = middleware['pages/media/podcast'].default || middleware['pages/media/podcast']

middleware['pages/media/podcasts'] = require('../middleware/pages/media/podcasts.js')
middleware['pages/media/podcasts'] = middleware['pages/media/podcasts'].default || middleware['pages/media/podcasts']

middleware['pages/media/pressclipping'] = require('../middleware/pages/media/pressclipping.js')
middleware['pages/media/pressclipping'] = middleware['pages/media/pressclipping'].default || middleware['pages/media/pressclipping']

middleware['pages/money'] = require('../middleware/pages/money.js')
middleware['pages/money'] = middleware['pages/money'].default || middleware['pages/money']

middleware['pages/partners'] = require('../middleware/pages/partners.js')
middleware['pages/partners'] = middleware['pages/partners'].default || middleware['pages/partners']

middleware['pages/press'] = require('../middleware/pages/press.js')
middleware['pages/press'] = middleware['pages/press'].default || middleware['pages/press']

middleware['pages/price-changes'] = require('../middleware/pages/price-changes.js')
middleware['pages/price-changes'] = middleware['pages/price-changes'].default || middleware['pages/price-changes']

middleware['pages/pricechanges'] = require('../middleware/pages/pricechanges.js')
middleware['pages/pricechanges'] = middleware['pages/pricechanges'].default || middleware['pages/pricechanges']

middleware['pages/privacy-policy'] = require('../middleware/pages/privacy-policy.js')
middleware['pages/privacy-policy'] = middleware['pages/privacy-policy'].default || middleware['pages/privacy-policy']

middleware['pages/products/banking/credit-cards/index'] = require('../middleware/pages/products/banking/credit-cards/index.js')
middleware['pages/products/banking/credit-cards/index'] = middleware['pages/products/banking/credit-cards/index'].default || middleware['pages/products/banking/credit-cards/index']

middleware['pages/products/banking/credit-cards/provider'] = require('../middleware/pages/products/banking/credit-cards/provider.js')
middleware['pages/products/banking/credit-cards/provider'] = middleware['pages/products/banking/credit-cards/provider'].default || middleware['pages/products/banking/credit-cards/provider']

middleware['pages/products/banking/credit-cards/providers'] = require('../middleware/pages/products/banking/credit-cards/providers.js')
middleware['pages/products/banking/credit-cards/providers'] = middleware['pages/products/banking/credit-cards/providers'].default || middleware['pages/products/banking/credit-cards/providers']

middleware['pages/products/banking/credit-cards/rate-changes'] = require('../middleware/pages/products/banking/credit-cards/rate-changes.js')
middleware['pages/products/banking/credit-cards/rate-changes'] = middleware['pages/products/banking/credit-cards/rate-changes'].default || middleware['pages/products/banking/credit-cards/rate-changes']

middleware['pages/products/banking/credit-cards/results'] = require('../middleware/pages/products/banking/credit-cards/results.js')
middleware['pages/products/banking/credit-cards/results'] = middleware['pages/products/banking/credit-cards/results'].default || middleware['pages/products/banking/credit-cards/results']

middleware['pages/products/banking/credit-cards/show'] = require('../middleware/pages/products/banking/credit-cards/show.js')
middleware['pages/products/banking/credit-cards/show'] = middleware['pages/products/banking/credit-cards/show'].default || middleware['pages/products/banking/credit-cards/show']

middleware['pages/products/banking/current-accounts/index'] = require('../middleware/pages/products/banking/current-accounts/index.js')
middleware['pages/products/banking/current-accounts/index'] = middleware['pages/products/banking/current-accounts/index'].default || middleware['pages/products/banking/current-accounts/index']

middleware['pages/products/banking/current-accounts/provider'] = require('../middleware/pages/products/banking/current-accounts/provider.js')
middleware['pages/products/banking/current-accounts/provider'] = middleware['pages/products/banking/current-accounts/provider'].default || middleware['pages/products/banking/current-accounts/provider']

middleware['pages/products/banking/current-accounts/providers'] = require('../middleware/pages/products/banking/current-accounts/providers.js')
middleware['pages/products/banking/current-accounts/providers'] = middleware['pages/products/banking/current-accounts/providers'].default || middleware['pages/products/banking/current-accounts/providers']

middleware['pages/products/banking/current-accounts/rate-changes'] = require('../middleware/pages/products/banking/current-accounts/rate-changes.js')
middleware['pages/products/banking/current-accounts/rate-changes'] = middleware['pages/products/banking/current-accounts/rate-changes'].default || middleware['pages/products/banking/current-accounts/rate-changes']

middleware['pages/products/banking/current-accounts/results'] = require('../middleware/pages/products/banking/current-accounts/results.js')
middleware['pages/products/banking/current-accounts/results'] = middleware['pages/products/banking/current-accounts/results'].default || middleware['pages/products/banking/current-accounts/results']

middleware['pages/products/banking/current-accounts/show'] = require('../middleware/pages/products/banking/current-accounts/show.js')
middleware['pages/products/banking/current-accounts/show'] = middleware['pages/products/banking/current-accounts/show'].default || middleware['pages/products/banking/current-accounts/show']

middleware['pages/products/banking/loans/index'] = require('../middleware/pages/products/banking/loans/index.js')
middleware['pages/products/banking/loans/index'] = middleware['pages/products/banking/loans/index'].default || middleware['pages/products/banking/loans/index']

middleware['pages/products/banking/loans/lender'] = require('../middleware/pages/products/banking/loans/lender.js')
middleware['pages/products/banking/loans/lender'] = middleware['pages/products/banking/loans/lender'].default || middleware['pages/products/banking/loans/lender']

middleware['pages/products/banking/loans/lenders'] = require('../middleware/pages/products/banking/loans/lenders.js')
middleware['pages/products/banking/loans/lenders'] = middleware['pages/products/banking/loans/lenders'].default || middleware['pages/products/banking/loans/lenders']

middleware['pages/products/banking/loans/rate-changes'] = require('../middleware/pages/products/banking/loans/rate-changes.js')
middleware['pages/products/banking/loans/rate-changes'] = middleware['pages/products/banking/loans/rate-changes'].default || middleware['pages/products/banking/loans/rate-changes']

middleware['pages/products/banking/loans/results'] = require('../middleware/pages/products/banking/loans/results.js')
middleware['pages/products/banking/loans/results'] = middleware['pages/products/banking/loans/results'].default || middleware['pages/products/banking/loans/results']

middleware['pages/products/banking/loans/show'] = require('../middleware/pages/products/banking/loans/show.js')
middleware['pages/products/banking/loans/show'] = middleware['pages/products/banking/loans/show'].default || middleware['pages/products/banking/loans/show']

middleware['pages/products/banking/mortgage/index'] = require('../middleware/pages/products/banking/mortgage/index.js')
middleware['pages/products/banking/mortgage/index'] = middleware['pages/products/banking/mortgage/index'].default || middleware['pages/products/banking/mortgage/index']

middleware['pages/products/banking/mortgage/journey'] = require('../middleware/pages/products/banking/mortgage/journey.js')
middleware['pages/products/banking/mortgage/journey'] = middleware['pages/products/banking/mortgage/journey'].default || middleware['pages/products/banking/mortgage/journey']

middleware['pages/products/banking/mortgage/lender'] = require('../middleware/pages/products/banking/mortgage/lender.js')
middleware['pages/products/banking/mortgage/lender'] = middleware['pages/products/banking/mortgage/lender'].default || middleware['pages/products/banking/mortgage/lender']

middleware['pages/products/banking/mortgage/lenders'] = require('../middleware/pages/products/banking/mortgage/lenders.js')
middleware['pages/products/banking/mortgage/lenders'] = middleware['pages/products/banking/mortgage/lenders'].default || middleware['pages/products/banking/mortgage/lenders']

middleware['pages/products/banking/mortgage/rate-changes'] = require('../middleware/pages/products/banking/mortgage/rate-changes.js')
middleware['pages/products/banking/mortgage/rate-changes'] = middleware['pages/products/banking/mortgage/rate-changes'].default || middleware['pages/products/banking/mortgage/rate-changes']

middleware['pages/products/banking/mortgage/results'] = require('../middleware/pages/products/banking/mortgage/results.js')
middleware['pages/products/banking/mortgage/results'] = middleware['pages/products/banking/mortgage/results'].default || middleware['pages/products/banking/mortgage/results']

middleware['pages/products/banking/mortgage/show'] = require('../middleware/pages/products/banking/mortgage/show.js')
middleware['pages/products/banking/mortgage/show'] = middleware['pages/products/banking/mortgage/show'].default || middleware['pages/products/banking/mortgage/show']

middleware['pages/products/banking/mortgage/stage'] = require('../middleware/pages/products/banking/mortgage/stage.js')
middleware['pages/products/banking/mortgage/stage'] = middleware['pages/products/banking/mortgage/stage'].default || middleware['pages/products/banking/mortgage/stage']

middleware['pages/products/banking/mortgage/thank-you'] = require('../middleware/pages/products/banking/mortgage/thank-you.js')
middleware['pages/products/banking/mortgage/thank-you'] = middleware['pages/products/banking/mortgage/thank-you'].default || middleware['pages/products/banking/mortgage/thank-you']

middleware['pages/products/banking/prepay-cards/index'] = require('../middleware/pages/products/banking/prepay-cards/index.js')
middleware['pages/products/banking/prepay-cards/index'] = middleware['pages/products/banking/prepay-cards/index'].default || middleware['pages/products/banking/prepay-cards/index']

middleware['pages/products/banking/prepay-cards/provider'] = require('../middleware/pages/products/banking/prepay-cards/provider.js')
middleware['pages/products/banking/prepay-cards/provider'] = middleware['pages/products/banking/prepay-cards/provider'].default || middleware['pages/products/banking/prepay-cards/provider']

middleware['pages/products/banking/prepay-cards/providers'] = require('../middleware/pages/products/banking/prepay-cards/providers.js')
middleware['pages/products/banking/prepay-cards/providers'] = middleware['pages/products/banking/prepay-cards/providers'].default || middleware['pages/products/banking/prepay-cards/providers']

middleware['pages/products/banking/prepay-cards/rate-changes'] = require('../middleware/pages/products/banking/prepay-cards/rate-changes.js')
middleware['pages/products/banking/prepay-cards/rate-changes'] = middleware['pages/products/banking/prepay-cards/rate-changes'].default || middleware['pages/products/banking/prepay-cards/rate-changes']

middleware['pages/products/banking/prepay-cards/results'] = require('../middleware/pages/products/banking/prepay-cards/results.js')
middleware['pages/products/banking/prepay-cards/results'] = middleware['pages/products/banking/prepay-cards/results'].default || middleware['pages/products/banking/prepay-cards/results']

middleware['pages/products/banking/prepay-cards/show'] = require('../middleware/pages/products/banking/prepay-cards/show.js')
middleware['pages/products/banking/prepay-cards/show'] = middleware['pages/products/banking/prepay-cards/show'].default || middleware['pages/products/banking/prepay-cards/show']

middleware['pages/products/banking/savings-accounts/index'] = require('../middleware/pages/products/banking/savings-accounts/index.js')
middleware['pages/products/banking/savings-accounts/index'] = middleware['pages/products/banking/savings-accounts/index'].default || middleware['pages/products/banking/savings-accounts/index']

middleware['pages/products/banking/savings-accounts/provider'] = require('../middleware/pages/products/banking/savings-accounts/provider.js')
middleware['pages/products/banking/savings-accounts/provider'] = middleware['pages/products/banking/savings-accounts/provider'].default || middleware['pages/products/banking/savings-accounts/provider']

middleware['pages/products/banking/savings-accounts/providers'] = require('../middleware/pages/products/banking/savings-accounts/providers.js')
middleware['pages/products/banking/savings-accounts/providers'] = middleware['pages/products/banking/savings-accounts/providers'].default || middleware['pages/products/banking/savings-accounts/providers']

middleware['pages/products/banking/savings-accounts/rate-changes'] = require('../middleware/pages/products/banking/savings-accounts/rate-changes.js')
middleware['pages/products/banking/savings-accounts/rate-changes'] = middleware['pages/products/banking/savings-accounts/rate-changes'].default || middleware['pages/products/banking/savings-accounts/rate-changes']

middleware['pages/products/banking/savings-accounts/results'] = require('../middleware/pages/products/banking/savings-accounts/results.js')
middleware['pages/products/banking/savings-accounts/results'] = middleware['pages/products/banking/savings-accounts/results'].default || middleware['pages/products/banking/savings-accounts/results']

middleware['pages/products/banking/savings-accounts/search'] = require('../middleware/pages/products/banking/savings-accounts/search.js')
middleware['pages/products/banking/savings-accounts/search'] = middleware['pages/products/banking/savings-accounts/search'].default || middleware['pages/products/banking/savings-accounts/search']

middleware['pages/products/banking/savings-accounts/show'] = require('../middleware/pages/products/banking/savings-accounts/show.js')
middleware['pages/products/banking/savings-accounts/show'] = middleware['pages/products/banking/savings-accounts/show'].default || middleware['pages/products/banking/savings-accounts/show']

middleware['pages/products/broadband/apply'] = require('../middleware/pages/products/broadband/apply.js')
middleware['pages/products/broadband/apply'] = middleware['pages/products/broadband/apply'].default || middleware['pages/products/broadband/apply']

middleware['pages/products/broadband/index'] = require('../middleware/pages/products/broadband/index.js')
middleware['pages/products/broadband/index'] = middleware['pages/products/broadband/index'].default || middleware['pages/products/broadband/index']

middleware['pages/products/broadband/price-changes'] = require('../middleware/pages/products/broadband/price-changes.js')
middleware['pages/products/broadband/price-changes'] = middleware['pages/products/broadband/price-changes'].default || middleware['pages/products/broadband/price-changes']

middleware['pages/products/broadband/provider'] = require('../middleware/pages/products/broadband/provider.js')
middleware['pages/products/broadband/provider'] = middleware['pages/products/broadband/provider'].default || middleware['pages/products/broadband/provider']

middleware['pages/products/broadband/providers'] = require('../middleware/pages/products/broadband/providers.js')
middleware['pages/products/broadband/providers'] = middleware['pages/products/broadband/providers'].default || middleware['pages/products/broadband/providers']

middleware['pages/products/broadband/results'] = require('../middleware/pages/products/broadband/results.js')
middleware['pages/products/broadband/results'] = middleware['pages/products/broadband/results'].default || middleware['pages/products/broadband/results']

middleware['pages/products/broadband/show'] = require('../middleware/pages/products/broadband/show.js')
middleware['pages/products/broadband/show'] = middleware['pages/products/broadband/show'].default || middleware['pages/products/broadband/show']

middleware['pages/products/broadband/thank-you'] = require('../middleware/pages/products/broadband/thank-you.js')
middleware['pages/products/broadband/thank-you'] = middleware['pages/products/broadband/thank-you'].default || middleware['pages/products/broadband/thank-you']

middleware['pages/products/protection/life-insurance/provider'] = require('../middleware/pages/products/protection/life-insurance/provider.js')
middleware['pages/products/protection/life-insurance/provider'] = middleware['pages/products/protection/life-insurance/provider'].default || middleware['pages/products/protection/life-insurance/provider']

middleware['pages/products/protection/life-insurance/providers'] = require('../middleware/pages/products/protection/life-insurance/providers.js')
middleware['pages/products/protection/life-insurance/providers'] = middleware['pages/products/protection/life-insurance/providers'].default || middleware['pages/products/protection/life-insurance/providers']

middleware['pages/reasons-why'] = require('../middleware/pages/reasons-why.js')
middleware['pages/reasons-why'] = middleware['pages/reasons-why'].default || middleware['pages/reasons-why']

middleware['pages/reviews'] = require('../middleware/pages/reviews.js')
middleware['pages/reviews'] = middleware['pages/reviews'].default || middleware['pages/reviews']

middleware['pages/speed-test'] = require('../middleware/pages/speed-test.js')
middleware['pages/speed-test'] = middleware['pages/speed-test'].default || middleware['pages/speed-test']

middleware['pages/terms'] = require('../middleware/pages/terms.js')
middleware['pages/terms'] = middleware['pages/terms'].default || middleware['pages/terms']

middleware['previews/car-insurance'] = require('../middleware/previews/car-insurance.js')
middleware['previews/car-insurance'] = middleware['previews/car-insurance'].default || middleware['previews/car-insurance']

middleware['previews/home-insurance'] = require('../middleware/previews/home-insurance.js')
middleware['previews/home-insurance'] = middleware['previews/home-insurance'].default || middleware['previews/home-insurance']

middleware['products'] = require('../middleware/products.js')
middleware['products'] = middleware['products'].default || middleware['products']

middleware['products/car-home-insurance-under-maintenance'] = require('../middleware/products/car-home-insurance-under-maintenance.js')
middleware['products/car-home-insurance-under-maintenance'] = middleware['products/car-home-insurance-under-maintenance'].default || middleware['products/car-home-insurance-under-maintenance']

middleware['products/car-insurance-order-steps'] = require('../middleware/products/car-insurance-order-steps.js')
middleware['products/car-insurance-order-steps'] = middleware['products/car-insurance-order-steps'].default || middleware['products/car-insurance-order-steps']

middleware['products/car-insurance-providers'] = require('../middleware/products/car-insurance-providers.js')
middleware['products/car-insurance-providers'] = middleware['products/car-insurance-providers'].default || middleware['products/car-insurance-providers']

middleware['products/car-insurance-steps'] = require('../middleware/products/car-insurance-steps.js')
middleware['products/car-insurance-steps'] = middleware['products/car-insurance-steps'].default || middleware['products/car-insurance-steps']

middleware['products/cover-types'] = require('../middleware/products/cover-types.js')
middleware['products/cover-types'] = middleware['products/cover-types'].default || middleware['products/cover-types']

middleware['products/home-insurance-steps'] = require('../middleware/products/home-insurance-steps.js')
middleware['products/home-insurance-steps'] = middleware['products/home-insurance-steps'].default || middleware['products/home-insurance-steps']

middleware['products/insurance-discount-providers'] = require('../middleware/products/insurance-discount-providers.js')
middleware['products/insurance-discount-providers'] = middleware['products/insurance-discount-providers'].default || middleware['products/insurance-discount-providers']

middleware['products/life-insurance-plan'] = require('../middleware/products/life-insurance-plan.js')
middleware['products/life-insurance-plan'] = middleware['products/life-insurance-plan'].default || middleware['products/life-insurance-plan']

middleware['products/life-insurance-steps'] = require('../middleware/products/life-insurance-steps.js')
middleware['products/life-insurance-steps'] = middleware['products/life-insurance-steps'].default || middleware['products/life-insurance-steps']

middleware['products/validations'] = require('../middleware/products/validations.js')
middleware['products/validations'] = middleware['products/validations'].default || middleware['products/validations']

middleware['provider-slugs'] = require('../middleware/provider-slugs.js')
middleware['provider-slugs'] = middleware['provider-slugs'].default || middleware['provider-slugs']

middleware['provider'] = require('../middleware/provider.js')
middleware['provider'] = middleware['provider'].default || middleware['provider']

middleware['providers'] = require('../middleware/providers.js')
middleware['providers'] = middleware['providers'].default || middleware['providers']

middleware['reset'] = require('../middleware/reset.js')
middleware['reset'] = middleware['reset'].default || middleware['reset']

middleware['searches/car-insurance'] = require('../middleware/searches/car-insurance.js')
middleware['searches/car-insurance'] = middleware['searches/car-insurance'].default || middleware['searches/car-insurance']

middleware['searches/home-insurance'] = require('../middleware/searches/home-insurance.js')
middleware['searches/home-insurance'] = middleware['searches/home-insurance'].default || middleware['searches/home-insurance']

middleware['searches/life-insurance'] = require('../middleware/searches/life-insurance.js')
middleware['searches/life-insurance'] = middleware['searches/life-insurance'].default || middleware['searches/life-insurance']

middleware['shared/cover-type'] = require('../middleware/shared/cover-type.js')
middleware['shared/cover-type'] = middleware['shared/cover-type'].default || middleware['shared/cover-type']

middleware['token'] = require('../middleware/token.js')
middleware['token'] = middleware['token'].default || middleware['token']

middleware['user'] = require('../middleware/user.js')
middleware['user'] = middleware['user'].default || middleware['user']

middleware['validations/home-insurance'] = require('../middleware/validations/home-insurance.js')
middleware['validations/home-insurance'] = middleware['validations/home-insurance'].default || middleware['validations/home-insurance']

middleware['validations/mortgages'] = require('../middleware/validations/mortgages.js')
middleware['validations/mortgages'] = middleware['validations/mortgages'].default || middleware['validations/mortgages']

export default middleware
